import { vsingleton } from '@niknevis/vue-modules'

@vsingleton()
export class DashboardStore {
  private itemsUpdated = false

  set itemsUpdate(value: boolean) {
    this.itemsUpdated = !this.itemsUpdated
  }

  get itemsUpdate() {
    return this.itemsUpdated
  }
}